// Modules
import cn from 'classnames';
import { createElement } from 'react';

// Types
import type { TTextColor, TTextProps } from './Text.type';

// Styles
import styles from './styles.module.scss';

// Helpers
import { snakeCase } from '../../helpers/typography';

// Constants
import { TEXT_AS_LIST, TEXT_COLORS, TEXT_DEFAULT_PROPS, TEXT_VARIANT } from './Text.constant';

const Text = (props: TTextProps) => {
  const {
    as,
    children,
    className,
    color = TEXT_DEFAULT_PROPS.color,
    fontType = TEXT_DEFAULT_PROPS.fontType,
    size = TEXT_DEFAULT_PROPS.size,
    style,
    /* Will be used in the future once the the UI is ready */
    // variant = TEXT_DEFAULT_PROPS.variant,
    weight,
    ...restProps
  } = props;
  const isValidTag = TEXT_AS_LIST.includes(as!);
  const isDefinedColor = TEXT_COLORS.includes(color as TTextColor);
  const sizeCN = RegExp(/^h[1-6]$/).test(size as string) ? styles[size!] : styles[snakeCase(size!)];
  const componentTag = isValidTag ? as : RegExp(/^h[1-6]$/).test(size as string) ? size : TEXT_DEFAULT_PROPS.as;
  const textCN = cn(
    className,
    styles.legion_text,
    styles[fontType!],
    sizeCN,
    /* Will be used in the future once the the UI is ready */
    // styles[snakeCase(variant)],
    styles[snakeCase(TEXT_VARIANT.medEmphasis)],
    {
      [styles[color!]]: isDefinedColor
    }
  );
  const textStyle = {
    ...style,
    ...(!isDefinedColor ? { color } : {}),
    ...(weight ? { fontWeight: weight } : {})
  };

  return createElement(
    componentTag!,
    { className: textCN, style: textStyle, ...restProps },
    children
  );
};

export default Text;
